import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeBaseComponentSkeleton } from './TypeBaseComponent'
import type { TypeCardBlockSkeleton } from './TypeCardBlock'

export interface TypeCardGridComponentFields {
  title: EntryFieldTypes.Symbol
  items: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeCardBlockSkeleton>>
  alignment: EntryFieldTypes.Symbol<'Centre' | 'Left' | 'Right'>
  anchorTag?: EntryFieldTypes.Symbol
  base: EntryFieldTypes.EntryLink<TypeBaseComponentSkeleton>
}

export type TypeCardGridComponentSkeleton = EntrySkeletonType<TypeCardGridComponentFields, 'cardGridComponent'>
export type TypeCardGridComponent<Modifiers extends ChainModifiers, Locales extends LocaleCode> = Entry<
  TypeCardGridComponentSkeleton,
  Modifiers,
  Locales
>

export function isTypeCardGridComponent<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeCardGridComponent<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'cardGridComponent'
}
